// extracted by mini-css-extract-plugin
module.exports = {"page":"Confirm_page__35c2X","container":"Confirm_container__2Rxdn"};